const stripNewLinesFromString = (str: string): string => {
	// Covers: \r\n (Windows), \r (old Mac), \n (Unix),
	// \u2028 (Unicode Line Separator), \u2029 (Unicode Paragraph Separator)
	return str.replace(/\r\n|\r|\n|\u2028|\u2029/g, ' ').trim();
};

export default stripNewLinesFromString;
